import { API_BASE_URL } from "../../constant/constant";
import { PlusOutlined } from "@ant-design/icons";
import { Button, Divider, Flex, Typography, message } from "antd";
import React from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useTranslation } from "react-i18next";

import BackIcon from "../../assets/back-icon.svg";
import SkillsTable from "./SkillsTable";
import { Container, Content, Header, Heading } from "./Style";
import axios from "axios";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useSnackbar } from "../../context/SnackBarContext";


export default function Skills() {
  const { t } = useTranslation();
  const { isSidebarOpen } = useOutletContext();
  const navigate = useNavigate();
  const showSnackbar = useSnackbar();

  const handleAddSkill = async () => {
    try {
      const userId = localStorage.getItem("id");
      const response = await axios.get(
        `${API_BASE_URL}/api/skill/user/` + userId,
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": `${localStorage.getItem("token")}`,
          },
        }
      );

      if (response.data.responseCode === 429){
        showSnackbar(response.data.message, "error");
        return;
      }

      if (response.data.skills.length >= 7) {
        message.warning(t("skills.maxLimit"));
        return;
      }

      navigate("/add-skills");
    } catch (error) {
      message.error(t("skills.fetchError"));
    }
  };

  return (
    <Container isOpen={isSidebarOpen}>
      <Header
        onClick={() => navigate("/")}
        style={{ display: "flex", alignItems: "center", gap: "8px" }}
      >
        <img src={BackIcon} alt="back" />

        <Heading style={{ marginBottom: 0 }}>
          {t("skills.title")}
        </Heading>

        <Tooltip
          title={t("skills.tooltip")}
          placement="top"
        >
          <InfoCircleOutlined
            style={{
              fontSize: 14,
              color: "#8c8c8c",
              cursor: "pointer",
            }}
            onClick={(e) => e.stopPropagation()} // prevent back navigation
          />
        </Tooltip>
      </Header>


      <Content>
        <Flex
          style={{ margin: "0px 36px 0px 36px", paddingTop: "24px" }}
          gap="middle"
          align="center"
          justify="space-between"
        >
          <Typography.Title style={{ margin: 0 }} level={3}>
            {t("skills.mySkill")}
          </Typography.Title>

          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={handleAddSkill}
            style={{ backgroundColor: "#51307F" }}
          >
            {t("skills.addNew")}
          </Button>
        </Flex>

        <Divider />

        <div style={{ padding: "0px 36px 0px 36px" }}>
          <SkillsTable />
        </div>
      </Content>
    </Container>
  );
}
